import { useWatch } from 'react-hook-form';
import { FlagSelectField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import {
    ProductChargingMode,
    ProductOptions,
    ProductPostingMode,
    ServiceType,
    TimeUnitPeriod,
} from '@mews-commander/data-access';
import { useCurrentService } from '../../queries/useCurrentService';

export const OptionsSelectField = () => {
    const { data } = useCurrentService();
    const pricingCharging = useWatch({ name: 'pricing.charging' });

    return (
        <FlagSelectField<ProductOptions>
            autoFocus
            name="options"
            label={lt('ProductOptions')}
            flagName="ProductOptions"
            flagValues={[
                'billAsPackage',
                'createTask',
                'excludePriceFromOffer',
                'offerToCustomer',
                'offerToEmployee',
                'proRataCharging',
                'selectedByDefault',
            ]}
            excludedValues={{
                proRataCharging:
                    (data.discriminator === ServiceType.Bookable &&
                        data.value.timeUnitPeriod !== TimeUnitPeriod.Month) ||
                    pricingCharging === ProductChargingMode.PerPerson ||
                    pricingCharging === ProductChargingMode.Once ||
                    pricingCharging === ProductPostingMode.Once,
            }}
            multiselect
        />
    );
};
